import { STORE_APP_BANNER_ENTRY, IS_DJI_STORE, IS_DJI_MIMO, IS_DJI_MIMO_IOS, MIMO_APP_LIST_ENTRY } from '../constants/index';

export const handleBannerAdResourceUrl = (url: string) => {
  return url.indexOf("https://") < 0 ? process.env.RESOURCE_URL+ 'data/attachment/' + url : url
}

/**
 * 判断是否为商城APP内&URL链接标识符匹配正确
 * @param entry URL链接标识符
 * @return true/false
 */
export const isStoreAppBannerEntry = (entry: string | string[] | undefined, ua?: string): boolean => {
  let isDjiStore = IS_DJI_STORE;
  if (ua) {
    isDjiStore = /DJI-App-(Ios|Android)/i.test(ua);
  }
  if (entry === undefined) {
    return false;
  }
  if (typeof entry === 'string') {
    // app嵌入webview banner配置的链接内参数后面有可能携带'/'
    return (entry === STORE_APP_BANNER_ENTRY || entry === `${STORE_APP_BANNER_ENTRY}/`) && isDjiStore;
  }
  if (Array.isArray(entry)) {
    return (entry.includes(STORE_APP_BANNER_ENTRY) || entry.includes(`${STORE_APP_BANNER_ENTRY}/`)) && isDjiStore;
  }
  return false;
};

/**
 * 判断是否为mimo APP内首页社区资源位&URL链接标识符匹配正确
 * @return true/false
 */
export const isMimoHomeListEntry = (): boolean => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const entry = (url.searchParams.get('entry')) || '' as string | string[] | undefined;
  let isDjiMimo = IS_DJI_MIMO;
  if (entry === undefined) {
    return false;
  }
  if (typeof entry === 'string') {
    // app嵌入webview banner配置的链接内参数后面有可能携带'/'
    return (entry === MIMO_APP_LIST_ENTRY || entry === `${MIMO_APP_LIST_ENTRY}/`) && isDjiMimo;
  }
  if (Array.isArray(entry)) {
    return (entry.includes(MIMO_APP_LIST_ENTRY) || entry.includes(`${MIMO_APP_LIST_ENTRY}/`)) && isDjiMimo;
  }
  return false;
};

/**
 * 判断是否为mimo ios APP内首页社区资源位&URL链接标识符匹配正确
 * @return true/false
 */
export const isMimoIosHomeListEntry = (): boolean => {
  if (isMimoHomeListEntry()) {
    return IS_DJI_MIMO_IOS;
  }
  return false;
};

/**
 * 判断是否为有效域名
 * 该函数用于检验字符串是否为合法的域名格式
 * 安全性验证包括：
 * 1. 检查是否为base64编码（如果是base64则视为不安全）
 * 2. 校验是否符合域名格式规范
 * 
 * @param domain 待验证的域名字符串或URL
 * @return 返回true表示是合法域名，false表示非法域名
 */
export const isValidDomain = (domain: string): boolean => {
  // 对URL进行预处理，提取域名部分
  let hostname = domain;

  try {
    // 检查是否以//开头的URL
    if (domain.startsWith('//')) {
      hostname = domain.substring(2).split('/')[0].split('?')[0];
    } 
    // 检查是否是完整URL
    else if (domain.includes('://') || domain.includes('/')) {
      // 尝试创建URL对象来解析
      const url = new URL(domain.startsWith('https') ? domain : `https://${domain}`);
      hostname = url.hostname;
    }
  } catch (e) {
    // URL解析失败，继续使用原始值
  }

  // 允许的二级域名白名单
  const allowedDomains = [
    '.youku.com',
    '.skypixel.com',
    '.djivideos.com',
    '.qq.com',
    '.720yun.com',
    '.bilibili.com',
    '.b23.tv',
    '.aasky.net'
  ];
  
  return allowedDomains.some(allowedDomain => {
    return hostname.endsWith(allowedDomain.substring(1));
  });
};
